import { render, staticRenderFns } from "./permissionView.vue?vue&type=template&id=8c631ffe&scoped=true"
import script from "./permissionView.vue?vue&type=script&lang=js"
export * from "./permissionView.vue?vue&type=script&lang=js"
import style0 from "./permissionView.vue?vue&type=style&index=0&id=8c631ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c631ffe",
  null
  
)

export default component.exports